
import { Component, Prop, Vue } from "vue-property-decorator";
import AddOfferModal from "@/components/Modals/Offers/AddOfferModal.vue";

@Component({ components: { AddOfferModal } })
export default class QuickAddOffer extends Vue {
  @Prop() step!: number;
  @Prop() installation!: Record<string, any>;
}
